import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Fortune Cloud Solutions";

export default function SEO({ title, description, name, type, keywords, canonical }) {
    const pageTitle = title === SITE_NAME ? SITE_NAME : `${title} | ${SITE_NAME}`;

    useEffect(() => {
        document.title = pageTitle;
    }, [pageTitle]);

    const url = canonical || "https://fcsglobal.us/";

    return (
        <Helmet>
            { /* Standard metadata tags */}
            <title>{pageTitle}</title>
            <meta name='description' content={description} />
            {keywords && <meta name='keywords' content={keywords} />}
            <link rel="canonical" href={url} />
            { /* End standard metadata tags */}

            { /* Facebook tags */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            { /* End Facebook tags */}

            { /* Twitter tags */}
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content={type} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            { /* End Twitter tags */}
        </Helmet>
    );
}
